module.exports = __webpack_public_path__ + "static/media/pc1.df18d857.webp";